import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import auth from "../reducers/auth";
import agencies from './agencies';
import notifications from '../reducers/notifications'
import notifs from '../reducers/notifs'
import users from '../reducers/users'
import user_groups from '../reducers/user_groups'

import pharmacies from '../reducers/pharmacies'
import pharmacy_types from './pharmacy_types';
import pharmacy_groups from './pharmacy_groups';
import grand_magazia from './grand_magazia';
import representatives from '../reducers/representatives'

import beauty_advisors from '../reducers/beauty_advisors'
import reservations from '../reducers/reservations'
import leaves_of_absense from '../reducers/leaves_of_absense'
import regions from '../reducers/regions'
import subregions from './subregions'
import holidays from './holidays'
import seasons from './seasons';
import brands from './brands';
import incidents from './incidents';
import incident_bas from './incident_bas';
import trainers from './trainers';
import trainees from './trainees';
import managers from './managers';
import reservation_reviews from './reservation_reviews';
import reservation_ba_reviews from './reservation_ba_reviews';
import reservation_rep_reviews from './reservation_rep_reviews';
import training_reviews from './training_reviews';
import training_notification_rules from './training_notification_rules';

import availabilities from './availabilities';
import trainer_availabilities from './trainer_availabilities';

import seminar_requests from './seminar_requests';
import trainings from './trainings';
import secretaries from './secretaries';
import marketers from './marketers';
import tasks from './tasks';
import media from './media';

// eslint-disable-next-line
export default (history) => combineReducers({
    router: connectRouter(history),
    auth,
    agencies,
    notifications,
    notifs,
    pharmacies,
    pharmacy_types,
    pharmacy_groups,
    grand_magazia,
    representatives,
    beauty_advisors,
    regions,
    subregions, 
    users,
    user_groups,
    holidays,
    reservations,
    leaves_of_absense,
    seasons,
    brands,
    reservation_reviews,
    trainers,
    managers,
    incidents,
    incident_bas,
    availabilities,
    seminar_requests,
    secretaries,
    tasks,
    reservation_ba_reviews,
    reservation_rep_reviews,
    trainings,
    trainees,
    training_reviews,
    trainer_availabilities,
    training_notification_rules,
    marketers,
    media
});